import React, { useEffect, useState } from 'react';
import './VerticalTab.scss';
import { isMobile } from 'react-device-detect';
import { Dropdown } from 'react-bootstrap';
import DownArrow from '@/assets/img/down-arrow.svg';
import { UseScreenOrientation } from '@/utils/Orientation';

type TabProps = {
  onChange: (item: number) => void;
  selectedTabIndex: number;
  tabs: any[];
  appointmentsCount?: undefined;
};
export const VerticalTabs = ({ onChange, selectedTabIndex, tabs }: TabProps) => {
  const [selectedIndex, setSelectedIndex] = useState<number>(0);
  const isLandscape = UseScreenOrientation();
  useEffect(() => {
    setSelectedIndex(selectedTabIndex);
  }, []);
  const onTabClicked = (index: number) => {
    setSelectedIndex(index);
    onChange(index);
  };
  const selectedTab = tabs[selectedIndex];
  return (
    <>
      {!isLandscape ? (
        <div className="tabs-dropdown">
          <Dropdown>
            <Dropdown.Toggle
              variant="success"
              className="drop-down-btn dropdown-toggle btn btn-success"
              id="dropdown-basic"
            >
              <span>
                <selectedTab.selectedIcon className={selectedTab.key} />
              </span>
              {selectedTab && selectedTab.label}
              <img src={DownArrow} className="down-arrow" />
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {tabs &&
                tabs?.map((tab, index) => {
                  return (
                    <Dropdown.Item
                      key={`dropdown-item-${index}`}
                      onClick={() => {
                        onTabClicked(index);
                      }}
                    >
                      <tab.icon />
                      {tab.label}
                    </Dropdown.Item>
                  );
                })}
            </Dropdown.Menu>
          </Dropdown>
        </div>
      ) : (
        <div className="vertical-tabs">
          {tabs.map((tab, index) => (
            <div
              key={`dropdown-item-${index}`}
              className={`vertical-tab-item ${index == selectedIndex ? 'active' : ''}`}
              onClick={() => onTabClicked(index)}
            >
              <span>{index == selectedIndex ? <tab.selectedIcon /> : <tab.icon />}</span>
              {tab && tab?.label}
            </div>
          ))}
        </div>
      )}
    </>
  );
};
